import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ErrorDetails } from '../../interfaces/apiInterfaces.d';

export class GetTotalsSurrenderCommand extends IRequestCommand<
  IGetTotalsSurrenderResponse,
  ErrorDetails,
  IGetTotalsSurrenderCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/travels/surrendersReports/totals?';

  public override setParameters(parameters: IGetTotalsSurrenderCommandParameters) {
    this._commandUrl = this._commandUrl.replace('{carrierId}', parameters.carrierId);
    this._commandUrl += parameters.driverId ? `&driverId=${parameters.driverId}` : '';
    this._commandUrl += parameters.ownerId ? `&ownerId=${parameters.ownerId}` : '';
    this._commandUrl += parameters.domain && parameters.domain.length > 0 ? `&domain=${parameters.domain}` : '';
    this._commandUrl += parameters.from && parameters.from.length > 0 ? `&from=${parameters.from}` : '';
    this._commandUrl += parameters.to && parameters.to.length > 0 ? `&to=${parameters.to}` : '';
  }
}

export interface IGetTotalsSurrenderCommandParameters extends ICommandParameters {
  carrierId: string;
  driverId?: string;
  ownerId?: string;
  domain?: string;
  from?: string;
  to?: string;
}

export interface IGetTotalsSurrenderResponse extends ICommandResponse {
  sumTotalBilling?: number;
  sumAgencyCommission?: number;
  sumOwnerCommission?: number;
  sumDriverCommission?: number;
  sumTotalCash?: number;
  sumTotalCheckingAccount?: number;
  sumTotalCreditCard?: number;
  sumTotalCharges?: number;
  sumTotalTravelsQty?: number;
  sumTotalFinancialCostDriver?: number;
  sumTotalFinancialCostOwner?: number;
}
